import PropTypes from "prop-types";

const _Breadcrumb = PropTypes.shape({
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
});

export const BreadcrumbPropTypes = _Breadcrumb;
